import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import LoadingSpinner from '../../../../components/UI/LoadingSpinner/LoadingSpinner';
import Button from '../../../../components/UI/Button/Button';
import { downloadFile, getSafe } from '../../../../shared/utility';
import {
  TARGET_SELECTION_SELECTED_TARGET,
  TARGET_SELECTION_TARGETS,
  TEST_CONFIG_DYNAMIC_FIELDS,
  TEST_CONFIG_FIELDS,
  TEST_CONFIG_FUSES,
  TEST_CONFIG_STRAPS,
} from '../../../../shared/const/Routes/statePaths';
import { downloadListFile } from '../../../../store/actions/jobConfiguration/jobConfiguration';
import {
  FUSE_EDIT_TABLE,
  STRAP_EDIT_TABLE,
} from '../../../../shared/const/GenericTableParams/TestConfigurationTables';

// const JOB_SUMMARY = 'JobConfiguration';
const DOWNLOAD_JSON = 'DOWNLOAD .LIST';

const DownloadJson = props => {
  const fields = useSelector(state => getSafe(TEST_CONFIG_FIELDS, state));
  const dynamicFields = useSelector(state =>
    getSafe(TEST_CONFIG_DYNAMIC_FIELDS, state)
  );
  const fusesData = useSelector(state => getSafe(TEST_CONFIG_FUSES, state));
  const strapsData = useSelector(state => getSafe(TEST_CONFIG_STRAPS, state));

  const targetsData = useSelector(state =>
    getSafe(TARGET_SELECTION_TARGETS, state)
  );
  const selectedTarget = useSelector(state =>
    getSafe(TARGET_SELECTION_SELECTED_TARGET, state)
  );

  const [isLoading, setIsLoading] = useState(false);
  const [listData, setListData] = useState(null);
  const [fuses, setFuses] = useState([]);
  const [straps, setStraps] = useState([]);

  useEffect(() => {
    setFuses(
      fusesData.filter(
        row =>
          row[FUSE_EDIT_TABLE.editColumnName] !=
          row[FUSE_EDIT_TABLE.defaultValueColumnName]
      )
    );
  }, [fusesData]);

  useEffect(() => {
    setStraps(
      strapsData.filter(
        row =>
          row[STRAP_EDIT_TABLE.editColumnName] !=
          row[STRAP_EDIT_TABLE.defaultValueColumnName]
      )
    );
  }, [strapsData]);

  useEffect(() => {
    const startDownload = async () => {
      if (!!listData) {
        const blobType = 'text/plain';
        const fileName = `${targetsData.filter(row => row.TargetId == selectedTarget)[0].TargetName}.list`;
        await downloadFile(listData, fileName, blobType);
        setIsLoading(false);
      } else setIsLoading(false);
    };
    startDownload();
  }, [listData]);

  const downloadJson = async () => {
    setIsLoading(true);
    let listFileData = await downloadListFile(
      fields,
      dynamicFields,
      fuses,
      straps,
      selectedTarget
    )();
    setListData(listFileData);
  };

  return (
    <div className="stage-content">
      <div className="stage-zero-btns-area">
        <Button
          className="project-button-short"
          onClick={async () => downloadJson()}
        >
          <i className="icon-export"></i>
          <label>{DOWNLOAD_JSON}</label>
        </Button>
      </div>
      {isLoading && (
        <div
          className="center-loading"
          style={{ margin: '6rem 0', width: '100%' }}
        >
          <LoadingSpinner text={'Loading...'} />
        </div>
      )}
    </div>
  );
};
export default DownloadJson;
